import { GetAllFilesDto, PlayersKycList, ServiceResponse } from '@alien-platform/bo-core';

export const getDocumentsList = async (appliedFilters: GetAllFilesDto): Promise<PlayersKycList | null | undefined> => {
  try {
    const res = await fetch(`/api/players/kyc`, {
      method: 'POST',
      body: JSON.stringify(appliedFilters),
      cache: 'no-store',
    });
    const data: ServiceResponse<PlayersKycList> = await res.json();
    if (res.ok && data.success) {
      return data.data;
    }
  } catch (e) {
    // console.error(e);
  }
};
